const QE_MAJOR_VERISON = 3;
const QE_MINOR_VERSION = 0;
const QE_PATCH_VERISON = 0;

export const QE_VERSION = `${QE_MAJOR_VERISON}.${QE_MINOR_VERSION}.${QE_PATCH_VERISON}`;
